import { Button } from 'rebass'
import styled from 'styled-components'
import { fonts, fontSizes, colors } from '../../theme'

const PrimaryButton = styled(Button)`
  font-family: ${fonts.primary};
  font-weight: 700;
  font-size: ${fontSizes[1] + 'px'};
  color: ${colors.primary};
  background-color: ${colors.secondary}!important;
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,.3);
  padding: 9px 15px;
  border-radius: 5px;
  transition: all 0.2s linear;
  border-radius: 3px;
  cursor: pointer;

  &:focus {
    box-shadow: none;
  }
`

export default PrimaryButton;


// WEBPACK FOOTER //
// ./src/elements/Button/PrimaryButton.js